import { FileCommand } from 'app/projects/core/src/lib/models/file.command';

export class UploadPrivateCertificateCommand extends FileCommand {
    constructor(assignmentRule: number, file: File) {
        super('file', file);

        this.formData.append('assignment_rule', assignmentRule.toString());
    }
}
